import { useEffect, useState } from 'react'

/**
 * 目標値に向かって滑らかにアニメーションする進捗値を管理するカスタムフック
 * @param targetProgress 目標進捗値（0-100）
 * @returns 現在の進捗値（アニメーション中）
 */
export const useSmoothProgress = (targetProgress: number) => {
  const [currentProgress, setCurrentProgress] = useState<number>(0)

  useEffect(() => {
    if (targetProgress === currentProgress) return

    const diff = targetProgress - currentProgress
    const step = Math.max(0.5, Math.abs(diff) * 0.1)

    const interval = setInterval(() => {
      setCurrentProgress((prev) => {
        if (Math.abs(targetProgress - prev) < step) {
          return targetProgress
        }
        return prev + (diff > 0 ? step : -step)
      })
    }, 50)

    return () => clearInterval(interval)
  }, [targetProgress, currentProgress])

  return currentProgress
}
